
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisAtonPhysicalSelectedIec as ObiAisAtonPhysicalSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-aton-physical-selected-iec.js';
 
 
 

 
 export const ObiAisAtonPhysicalSelectedIec = createComponent({
   react: React,
   tagName: 'obi-ais-aton-physical-selected-iec',
   elementClass: ObiAisAtonPhysicalSelectedIecElement,
   events: {
     
   }
  });
 
 